import { render, staticRenderFns } from "./Configuraciones.vue?vue&type=template&id=51ffc14a&"
import script from "./Configuraciones.vue?vue&type=script&lang=js&"
export * from "./Configuraciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports